import { cores, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { func_print } from "../../Func_genericas/func_print";
import { del, get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { Snackbar } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { loader } from "../../Func_genericas/loader";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { Alert } from "../../Components/Alert/Alert";
import { ICustoSchema, INota, IPlanoERPSchema, IReceita } from "../../Interfaces/financeiro/financeiro";
import { ICaderno } from "../../Interfaces/cadernos/caderno1";
import { IPage2 } from "../../Interfaces/cadernos/caderno2";
import { Modaladdfinanceiro } from "./add_financeiro";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modalverfinanceiro } from "./ver_financeiro";
import { Modalverlistacusto } from "./ver_lista_custos";
import { Modalverlistareceitas } from "./ver_lista_receitas";
import { Modalverlistanotas } from "./ver_lista_notas";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);
function Financeiro() {

  const classes = useStyles();

  const auth = useContext(AuthContext);
  const location = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [openSnackSuccess, setOpenSnackSuccess] = useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [open_dialog_tem_a_certeza_que_quer_eliminar_financeiro, set_open_dialog_tem_a_certeza_que_quer_eliminar_financeiro] = useState<boolean>(false);

  const [flag_open_modal_financeiro, set_flag_open_modal_financeiro] = useState<boolean>(false);
  const [flag_open_modal_financeiro_edit, set_flag_open_modal_financeiro_edit] = useState<boolean>(false);
  const [flag_open_modal_financeiro_add, set_flag_open_modal_financeiro_add] = useState<boolean>(false);
  const [flag_open_modal_financeiro_ver_mais, set_flag_open_modal_financeiro_ver_mais] = useState<boolean>(false);
  const [obj_new_financeiro, set_obj_new_financeiro] = useState<IPlanoERPSchema>();
  const [lista_de_financeiro, set_lista_de_financeiro] = useState<IPlanoERPSchema[]>([]);

  const [lista_cadernos_ativos, set_lista_cadernos_ativos] = useState<ICaderno[]>([]);
  const [lista_caraterizacao, set_lista_caraterizacao] = useState<IPage2[]>([]);

  const [flag_open_modal_custos, set_flag_open_modal_custos] = useState<boolean>(false);
  const [flag_open_modal_receitas, set_flag_open_modal_receitas] = useState<boolean>(false);
  const [flag_open_modal_notas, set_flag_open_modal_notas] = useState<boolean>(false);

  const [lista_de_custos, set_lista_de_custos] = useState<ICustoSchema[]>([]);
  const [lista_de_receitas, set_lista_de_receitas] = useState<IReceita[]>([]);
  const [lista_de_notas, set_lista_de_notas] = useState<INota[]>([]);

  const get_info = async () => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'api/plano-erp/agri/' + location.state);

      if (res.status === 200) {
        set_lista_de_financeiro(res.data.result);
      } else {
        func_print("get_info", res.data, true);
      }

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }
  const get_info_by_id_rosto = async () => {
    try {
      setIsLoading(true);
      let res_cadernos_ativos = await get(auth.token.cookie_token, `/get_cadernos_list_ativos/${auth.user?.id_org}`);

      if (res_cadernos_ativos.status === 200) {
        set_lista_cadernos_ativos(res_cadernos_ativos.data.result);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("get_info_by_id_rosto", error, true);
      setIsLoading(false);
    }
  }
  const get_info_plano_erp = async (id_plano: number) => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'api/plano-erp/' + id_plano);

      if (res.status === 200) {
        return res.data.result;
      } else {
        func_print("get_info_plano_erp", res.data, true);
        return undefined;
      }

    } catch (error) {
      func_print("get_info_plano_erp", error, true);
      return undefined;
    } finally {
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      await get_info();
      await get_info_by_id_rosto();
    })();
  }, []);


  const handle_delete_financeiro = async () => {
    try {
      setIsLoading(true);
      await del(auth.token.cookie_token, `/api/plano-erp/${obj_new_financeiro?.id_plano}`);
      lista_de_financeiro.splice(lista_de_financeiro.findIndex((financeiro) => financeiro.id_plano === obj_new_financeiro?.id_plano), 1);
      set_obj_new_financeiro(undefined);
      set_open_dialog_tem_a_certeza_que_quer_eliminar_financeiro(false);
      setMessage(operacao_sucesso);
      setOpenSnackSuccess(true);
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_financeiro", error, true);
      setIsLoading(false);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage(operacao_erro);
      }
      setOpenSnackError(true);
    }
  }


  return (
    <CustomThemeProvider>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>

      {
        flag_open_modal_financeiro === true &&
        <Modaladdfinanceiro
          lista={lista_de_financeiro}
          flag_open_modal={flag_open_modal_financeiro}
          set_flag_open_modal={set_flag_open_modal_financeiro}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_lista={set_lista_de_financeiro}
          flag_open_modal_ver_mais={flag_open_modal_financeiro_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_financeiro_ver_mais}
          flag_open_modal_edit={flag_open_modal_financeiro_edit}
          set_flag_open_modal_edit={set_flag_open_modal_financeiro_edit}
          flag_open_modal_add={flag_open_modal_financeiro_add}
          set_flag_open_modal_add={set_flag_open_modal_financeiro_add}
          set_obj_new={set_obj_new_financeiro}
          obj_new={obj_new_financeiro}
        />
      }

      {
        flag_open_modal_financeiro_ver_mais === true &&
        <Modalverfinanceiro
          flag_open_modal={flag_open_modal_financeiro}
          set_flag_open_modal={set_flag_open_modal_financeiro}
          obj_new={obj_new_financeiro}
          set_flag_open_modal_ver_mais={set_flag_open_modal_financeiro_ver_mais}
          lista_cadernos_ativos={lista_cadernos_ativos}
          lista_caraterizacao={lista_caraterizacao}
          set_lista_caraterizacao={set_lista_caraterizacao}
        />
      }
      {
        flag_open_modal_custos === true &&
        <Modalverlistacusto
          list={lista_de_custos}
          flag_open_modal={flag_open_modal_custos}
          set_flag_open_modal={set_flag_open_modal_custos}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_custos}
          obj_financeiro={obj_new_financeiro}
          set_obj_new_financeiro={set_obj_new_financeiro}
        />
      }
      {
        flag_open_modal_receitas === true &&
        <Modalverlistareceitas
          list={lista_de_receitas}
          flag_open_modal={flag_open_modal_receitas}
          set_flag_open_modal={set_flag_open_modal_receitas}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_receitas}
          obj_financeiro={obj_new_financeiro}
          set_obj_new_financeiro={set_obj_new_financeiro}

        />
      }
      {
        flag_open_modal_notas === true &&
        <Modalverlistanotas
          list={lista_de_notas}
          flag_open_modal={flag_open_modal_notas}
          set_flag_open_modal={set_flag_open_modal_notas}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list={set_lista_de_notas}
          obj_financeiro={obj_new_financeiro}
          set_obj_new_financeiro={set_obj_new_financeiro}

        />
      }

      <div className={classes.root}>
        <HomeViewTecnico title=" Financeiro" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div className={`${classes.label} p-4`}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1
            }}>


              {
                isLoading === true ?
                  loader() :
                  <>
                    <div className="p-5">
                      <button
                        type="button"
                        onClick={() => {
                          set_flag_open_modal_financeiro(true);
                          set_flag_open_modal_financeiro_edit(true);
                          set_flag_open_modal_financeiro_add(true);
                          set_obj_new_financeiro(undefined)

                        }}
                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                      >
                        <AddIcon sx={{ fontSize: 18 }} />
                        Adicionar Registo Financeiro
                      </button>
                    </div>

                    <div style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {
                        lista_de_financeiro.length === 0 ?

                          <div style={{}}
                            className="flex flex-col items-center gap-3"
                          >
                            <p className="text-gray-500 text-lg">Sem Planos ERP registados</p>
                          </div>
                          :
                          lista_de_financeiro.length > 0 ?

                          <div className="flex flex-wrap gap-4">
                          {lista_de_financeiro.map((financeiro, key) => {
                                return (
                                  <div
                                    key={key}
                                    className="w-[200px] min-w-[200px] rounded-2xl border border-gray-200 bg-stone-50 p-4 shadow-sm"
                                  >
                                    <div className="space-y-2 text-sm">
                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Nome</span>
                                        <span className="text-gray-800 font-medium truncate">
                                          {financeiro.nome || '-'}
                                        </span>
                                      </div>
                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Ano</span>
                                        <span className="text-gray-800 font-medium truncate">
                                          {financeiro.ano || '-'}
                                        </span>
                                      </div>
                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Descrição</span>
                                        <span className="text-gray-800 font-medium truncate">
                                          {financeiro.descricao || '-'}
                                        </span>
                                      </div>

                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Cultura</span>
                                        <span className="text-gray-800 font-medium">
                                          {financeiro.cultura}
                                        </span>
                                      </div>

                                      <div className="flex items-center justify-between gap-3">
                                        <span className="text-gray-500">Estado</span>
                                        <span className="text-gray-800 font-medium truncate">
                                          {financeiro.estado || '-'}
                                        </span>
                                      </div>
                                    </div>



                                    <div className="flex justify-between gap-2 mt-4">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          get_info_plano_erp(financeiro.id_plano).then((res) => {
                                            if (res) {
                                              set_obj_new_financeiro(res);
                                              set_flag_open_modal_financeiro(true);
                                              set_flag_open_modal_financeiro_ver_mais(true);
                                            } else {
                                              setMessage(operacao_erro);
                                              setOpenSnackError(true);
                                            }
                                          })

                                        }}
                                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                      >
                                        <VisibilityIcon sx={{ fontSize: 18 }} />
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          set_flag_open_modal_financeiro(true)
                                          set_obj_new_financeiro(financeiro)
                                          set_flag_open_modal_financeiro_edit(true)

                                        }}
                                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                      >
                                        <EditIcon sx={{ fontSize: 18 }} />
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          set_open_dialog_tem_a_certeza_que_quer_eliminar_financeiro(true)
                                          set_obj_new_financeiro(financeiro)

                                        }}
                                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                      >
                                        <DeleteIcon sx={{ fontSize: 18 }} />
                                      </button>

                                    </div>

                                    <div className="grid grid-cols gap-2 pt-2">


                                      <button
                                        type="button"
                                        onClick={() => {
                                          // abrir modal de custos

                                          if (financeiro.id_plano !== obj_new_financeiro?.id_plano || obj_new_financeiro?.id_plano === undefined || financeiro.id_plano === undefined) {


                                            get_info_plano_erp(financeiro.id_plano).then((res) => {
                                              if (res) {
                                                set_obj_new_financeiro(res);
                                                set_lista_de_custos(res.custos);
                                                set_flag_open_modal_custos(true);
                                              } else {
                                                setMessage(operacao_erro);
                                                setOpenSnackError(true);
                                              }
                                            })
                                          } else {
                                            set_lista_de_custos(obj_new_financeiro?.custos || []);
                                            set_flag_open_modal_custos(true);
                                          }
                                        }}
                                        className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-[#c94f1e] bg-orange-50 border border-orange-200 hover:bg-orange-100 transition-colors"
                                      >
                                        Custos
                                      </button>

                                      <button
                                        type="button"
                                        onClick={() => {
                                          // abrir modal de receitas
                                          if (financeiro.id_plano !== obj_new_financeiro?.id_plano || obj_new_financeiro?.id_plano === undefined || financeiro.id_plano === undefined) {


                                            get_info_plano_erp(financeiro.id_plano).then((res) => {
                                              if (res) {
                                                set_obj_new_financeiro(res);
                                                set_lista_de_receitas(res.receitas);
                                                set_flag_open_modal_receitas(true);
                                              } else {
                                                setMessage(operacao_erro);
                                                setOpenSnackError(true);
                                              }
                                            })
                                          } else {
                                            set_lista_de_receitas(obj_new_financeiro?.receitas || []);
                                            set_flag_open_modal_receitas(true);
                                          }
                                        }}
                                        className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-green-700 bg-green-50 border border-green-200 hover:bg-green-100 transition-colors"
                                      >
                                        Receitas
                                      </button>

                                      <button
                                        type="button"
                                        onClick={() => {
                                          // abrir modal de notas


                                          if (financeiro.id_plano !== obj_new_financeiro?.id_plano || obj_new_financeiro?.id_plano === undefined || financeiro.id_plano === undefined) {
                                            get_info_plano_erp(financeiro.id_plano).then((res) => {
                                              if (res) {
                                                set_obj_new_financeiro(res);
                                                set_lista_de_notas(res.notas);
                                                set_flag_open_modal_notas(true);
                                              } else {
                                                setMessage(operacao_erro);
                                                setOpenSnackError(true);
                                              }
                                            })
                                          } else {
                                            set_lista_de_notas(obj_new_financeiro?.notas || []);
                                            set_flag_open_modal_notas(true);
                                          }
                                        }}
                                        className="flex items-center justify-center rounded-xl px-3 py-2.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 hover:bg-blue-100 transition-colors"
                                      >
                                        Notas
                                      </button>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                            : <></>
                      }



                    </div>

                  </>
              }

            </div>



          </div>
        </main>
      </div>



      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar_financeiro}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_financeiro(false)}
        onConfirm={handle_delete_financeiro}
        message="Deseja eliminar o registo?"
      />

    </CustomThemeProvider>
  )



}

export default Financeiro;
